import { Col, Form, InputNumber, Row } from 'antd'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import React from 'react'

function SubComponentSku({ product, data, form }) {
  const { getFieldDecorator } = form

  const key = get(product, '_id', '').replace('products/', '')
  const [SubComponentSelect] = useFetchSelectUrl(
    {
      name: 'SubComponent',
      url: `products/lines/${key}`,
    },
    [key],
    isEmpty(product),
    undefined,
    undefined,
    undefined,
    undefined,
    (i) => {
      console.log(i._id, data._id)
      return data ? i._id !== data._id : Boolean
    }
  )

  return (
    <Row>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Sub Component Line'}>
          {getFieldDecorator('SubComponent._id', {
            initialValue: get(data, 'SubComponent._id'),
          })(<SubComponentSelect keyAtr={'_id'} valueAtr={'name'} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Units'}>
          {getFieldDecorator('SubComponent.units', {
            initialValue: get(data, 'SubComponent.units'),
          })(<InputNumber style={{ width: '100%' }} />)}
        </Form.Item>
      </Col>
    </Row>
  )
}

export default SubComponentSku
